import { AppRootStateType } from 'state/store';

export const doctorsSelect = (state: AppRootStateType) => state.doctors.doctors;
export const choosedUserSelect = (state: AppRootStateType) => state.users.user;
export const userLoadingSelect = (state: AppRootStateType) => state.users.isLoading;
export const doctorVisitsSelect = (state: AppRootStateType) => state.doctors.visits;
export const doctorFinancesSelect = (state: AppRootStateType) => state.doctors.finances;
export const financesSelect = (state: AppRootStateType) => state.finances.finances;
